// src/hooks/canvas/useCustomCursor.js
//
// Crosshair cursor positioning — canvas uzerinde X/Y cizgileri ve kucuk kutu.

import { useEffect, useRef } from 'react';
import { throttleRAF } from '../../../utils/throttle';

export default function useCustomCursor(canvasRef) {
  const cursorXRef = useRef(null);
  const cursorYRef = useRef(null);
  const cursorBoxRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = throttleRAF((e) => {
      if (!cursorXRef.current || !cursorYRef.current || !cursorBoxRef.current || !canvasRef.current) return;
      const container = canvasRef.current;
      const containerRect = container.getBoundingClientRect();
      const canvas = container.querySelector('canvas');
      if (!canvas) {
        cursorXRef.current.style.display = 'none';
        cursorYRef.current.style.display = 'none';
        cursorBoxRef.current.style.display = 'none';
        return;
      }
      const canvasRect = canvas.getBoundingClientRect();
      const canvasX = e.clientX - canvasRect.left;
      const canvasY = e.clientY - canvasRect.top;
      const offsetX = canvasRect.left - containerRect.left;
      const offsetY = canvasRect.top - containerRect.top;
      const displayX = canvasX + offsetX;
      const displayY = canvasY + offsetY;
      const isInside = canvasX >= 0 && canvasX <= canvasRect.width && canvasY >= 0 && canvasY <= canvasRect.height;
      const isOverCanvas = e.target.tagName === 'CANVAS';

      if (isInside && isOverCanvas) {
        cursorXRef.current.style.transform = `translate(${displayX - 30}px, ${displayY}px)`;
        cursorYRef.current.style.transform = `translate(${displayX}px, ${displayY - 30}px)`;
        cursorBoxRef.current.style.transform = `translate(${displayX - 5}px, ${displayY - 5}px)`;
        cursorXRef.current.style.display = 'block';
        cursorYRef.current.style.display = 'block';
        cursorBoxRef.current.style.display = 'block';
      } else {
        cursorXRef.current.style.display = 'none';
        cursorYRef.current.style.display = 'none';
        cursorBoxRef.current.style.display = 'none';
      }
    });
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      handleMouseMove.cancel();
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return { cursorXRef, cursorYRef, cursorBoxRef };
}
